<template>
    <on-click-outside :do="hide" v-if="isVisible">
        <div class="hint is-hidden-print" >
            Для просмотра информации щелкните на карте.
        </div>
    </on-click-outside>
</template>
<script>
	import OnClickOutside from "../common/OnClickOutside";

	export default {
		components: {
			OnClickOutside
		},
		data() {
			return {
				isVisible: true
			}
		},
		methods: {
			hide() {
				this.isVisible = false;
			}
		}
	};
</script>
<style lang="scss">
    @import '../../assets/sass/main.scss';

    .hint {
        position: absolute;
        left: 0;
        right: 0;
        top: 8em;
        margin: 0 auto;
        padding: 1.5em;
        max-width: 30em;
        border-radius: 9px;
        background-color: rgba(108, 197, 202, 0.8);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
        font-size: 16px;
        color: white;
        text-align: center;

        @include mobile {
            top: 14em;
            margin: 0 1rem;
        }
    }    
</style>